import { capitalDesignTokens, createTypedSxStyles } from "@opengov/capital-mui-theme";

export const styles = createTypedSxStyles({
  drawer: {
    width: "560px",
    flexShrink: 0,
    "& .MuiDrawer-paper": {
      width: "560px",
      boxSizing: "border-box",
      backgroundColor: capitalDesignTokens.semanticColors.background.primary,
      borderLeft: `1px solid ${capitalDesignTokens.semanticColors.border.secondary}`,
      marginTop: "53px",
      height: "calc(100% - 53px)",
      display: "flex",
      flexDirection: "column",
    },
    "& .MuiBackdrop-root": {
      backgroundColor: "transparent",
    },
  },
  menuItem: {
    display: "flex",
    alignItems: "flex-start",
    paddingY: "12px",
    // Matches the width the removed unread dot used to occupy, so the avatar keeps its position.
    paddingLeft: "8px",
    paddingRight: "24px",
    whiteSpace: "normal",
    backgroundColor: capitalDesignTokens.semanticColors.background.primary,
    "&:hover": {
      backgroundColor: capitalDesignTokens.semanticColors.interaction.hoverLight,
      "& .notification-title": {
        color: capitalDesignTokens.foundations.colors.blurple900,
      },
    },
    "&:not(:last-child)": {
      borderBottom: `1px solid ${capitalDesignTokens.semanticColors.border.secondary}`,
    },
  },
  menuItemUnread: {
    backgroundColor: capitalDesignTokens.semanticColors.interaction.selectionLight,
    "&:hover": {
      backgroundColor: capitalDesignTokens.semanticColors.interaction.hoverLight,
      "& .notification-title": {
        color: capitalDesignTokens.foundations.colors.blurple900,
      },
    },
  },
  // `foundations.colors` rather than a semantic token: semanticColors has no
  // feedback/status group, so there is no intent-level token for these states.
  typeAvatar: {
    width: "32px",
    height: "32px",
    minWidth: "32px",
    marginLeft: "12px",
    borderRadius: "50%",
    flexShrink: 0,
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    backgroundColor: capitalDesignTokens.foundations.colors.blue50,
    color: capitalDesignTokens.foundations.colors.blue600,
  },
  typeAvatarUrgent: {
    backgroundColor: capitalDesignTokens.foundations.colors.yellow100,
    color: capitalDesignTokens.foundations.colors.yellow600,
  },
  typeAvatarIcon: { fontSize: "16px" },
  contentColumn: {
    flex: 1,
    minWidth: 0,
    display: "flex",
    flexDirection: "column",
    alignItems: "flex-start",
    marginLeft: "12px",
  },
  title: {
    fontWeight: capitalDesignTokens.foundations.typography.fontWeight.semiBold,
  },
  bodyText: {
    overflow: "hidden",
    display: "-webkit-box",
    WebkitLineClamp: 2,
    WebkitBoxOrient: "vertical",
  },
  metaRow: {
    display: "flex",
    alignItems: "center",
    gap: "8px",
    marginTop: "4px",
  },
  bookmarkButton: {
    color: capitalDesignTokens.semanticColors.foreground.secondary,
    flexShrink: 0,
  },
  bookmarkButtonStarred: {
    color: capitalDesignTokens.semanticColors.foreground.action,
  },
  bookmarkIcon: {
    fontSize: "17px",
  },
  header: {
    width: "100%",
    flexShrink: 0,
    boxSizing: "border-box",
    display: "flex",
    flexDirection: "column",
  },
  headerRow: {
    paddingX: "16px",
    paddingTop: "16px",
    paddingBottom: "16px",
    flexShrink: 0,
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
  },
  unreadToggle: { margin: 0 },
  itemsContainer: { flex: 1, overflowY: "auto", minHeight: 0 },
  footer: {
    padding: "16px",
    borderTop: `1px solid ${capitalDesignTokens.semanticColors.border.secondary}`,
    flexShrink: 0,
  },
  footerRow: {
    display: "flex",
    alignItems: "center",
    justifyContent: "flex-end",
    width: "100%",
  },
  skeletonContainer: { paddingX: "16px", paddingY: "8px" },
  skeletonItem: { paddingY: "8px" },
  emptyStateContainer: { paddingTop: "32px" },
});
